// extracted by mini-css-extract-plugin
export default {"table":"SuccessNotice_table__LNqo1","container":"SuccessNotice_container__z709C","check":"SuccessNotice_check__koqwN"};